import { combineReducers } from "redux";
import { ApplicationStore } from "../../models/store";
import feedback from "./feedback";
import employee from "./employee";
import config from "./config";
import steps from './steps';
import navigationFromMenu from './navigationFromMenu';
import nextBtn from './nextBtn';
import eSign from './eSign';

export default combineReducers<ApplicationStore>({
  feedback,
  employee,
  config,
  steps,
  navigationFromMenu,
  nextBtn,
  eSign
});
